<template>
  <div itemscope itemtype="https://schema.org/WebPage">
    <Breadcrumb />
    <!-- 导航栏 -->
    <Navbar />
    
    <!-- 主要内容区域 -->
    <main role="main">
      <!-- 英雄区域 -->
      <section aria-label="公司介绍">
        <Hero />
      </section>
      
      <!-- 合作伙伴 -->
      <section aria-label="合作伙伴">
        <Sponsors />
      </section>
      
      <!-- 产品服务 -->
      <section aria-label="智能产品与服务">
        <Services />
      </section>
      
      <!-- 核心优势 -->
      <section aria-label="技术优势">
        <Benefits />
      </section>
      
      <!-- 产品特色 -->
      <section aria-label="产品特色功能">
        <Features />
      </section>
      
      <!-- 工作流程 -->
      <section aria-label="服务流程">
        <HowItWorks />
      </section>
      
      <!-- 常见问题 -->
      <section aria-label="常见问题解答">
        <FAQ />
      </section>
      
      <!-- 团队介绍 -->
      <section aria-label="专业团队">
        <Team />
      </section>
      
      <!-- 客户评价 -->
      <section aria-label="客户案例与评价">
        <Testimonials />
      </section>
      
      <!-- 价格方案 -->
      <section aria-label="解决方案价格">
        <Pricing />
      </section>
      
      <!-- 联系我们 -->
      <section aria-label="联系方式">
        <Contact />
      </section>
      
      <!-- 技术博客预览 -->
      <section aria-label="技术博客与行业洞察">
        <BlogPreview />
      </section>
    </main>
    
    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script setup lang="ts">
import Breadcrumb from '@/components/Breadcrumb.vue'
import Navbar from '@/components/Navbar.vue'
import Hero from '@/components/Hero.vue'
import Sponsors from '@/components/Sponsors.vue'
import Services from '@/components/Services.vue'
import Benefits from '@/components/Benefits.vue'
import Features from '@/components/Features.vue'
import HowItWorks from '@/components/HowItWorks.vue'
import FAQ from '@/components/FAQ.vue'
import Team from '@/components/Team.vue'
import Testimonials from '@/components/Testimonials.vue'
import BlogPreview from '@/components/BlogPreview.vue'
import Pricing from '@/components/Pricing.vue'
import Contact from '@/components/Contact.vue'
import Footer from '@/components/Footer.vue'
</script>

